import {parseLocationResponse, collections as collectionsDuck} from '@eb/destination-utils';
import {deepKeysToCamel} from 'js-utils/transformation';

import {
    // transformBucketsContent,
    transformFeatureFlagsWithExperiments,
} from '../utils/transformation';

const {
    utils: {
        transformCollectionResponse,
    },
} = collectionsDuck;

export const transformFiveToFollowResponse = (fiveToFollow) => (
    fiveToFollow && deepKeysToCamel(fiveToFollow)
);

export const getInitialState = (props) => {
    const {
        // buckets,
        experiments,
        featureFlags,
        gaSettings,
        locationSlug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        placeType,
        locations,
        userCollections,
        fiveToFollow,
        flatBucket,
        isOnline,
        env: {
            currencyFormat,
            ebDomain: domain,
            isMobile,
            localeInfo: {
                // every locale can use a different twitter account and
                // facebook account, so we need to use them in order to build
                // share messages
                'twitter_handle': twitterHandle,
                'facebook_locale': facebookLocale,
                'facebook_page': facebookPage,
            },
            serverUrl,
        },
        facebookOptions,
        user: {
            isAuthenticated,
            publicId,
            canCreateEvents,
        },
        // eslint-disable-next-line camelcase
        __server_skipped_context_data,
    } = props;

    // const {entities, entityContext} = transformBucketsContent(buckets);

    return {
        currencyFormat,
        gaSettings,
        app: {
            domain,
            experiments,
            featureFlags: transformFeatureFlagsWithExperiments(featureFlags, experiments),
            isMobile,
        },
        content: {
            // entities,
            // entityContext,
            flatBucket,
        },
        collections: transformCollectionResponse(userCollections),
        fiveToFollow: transformFiveToFollowResponse(fiveToFollow),
        location: {
            slug: locationSlug,
            placeId,
            latitude,
            longitude,
            currentPlace,
            currentPlaceParent,
            placeType,
            topSuggestions: locations ? parseLocationResponse(locations) : [],
            isOnline,
        },
        search: {
            slug: locationSlug,
            placeId,
            latitude,
            longitude,
            currentPlace,
            currentPlaceParent,
            placeType,
            topSuggestions: locations ? parseLocationResponse(locations) : [],
        },
        user: {
            isAuthenticated,
            publicId,
            canCreateEvents,
        },
        // eslint-disable-next-line camelcase
        isLoading: !!__server_skipped_context_data,
        shareOptions: {
            isMobile,
            twitterHandle,
            serverUrl,
            facebookOptions: {
                ...facebookOptions,
                locale: facebookLocale,
                page: facebookPage,
            },
        },
    };
};
